import {
  ChangeDetectionStrategy,
  Component, ComponentFactoryResolver,
  Injector, Input, OnDestroy, ViewChild, ViewContainerRef,
} from '@angular/core';
import {PlayerBase} from "./player.base";
import {Observable, of} from "rxjs";
import {CachingService} from "../services/caching/caching.service";
import {catchError, switchMap} from "rxjs/operators";
import {SceneComponent} from "../components/scene/scene.component";
import {PlayerBaseService} from "../services/PlayerService/player.base.service";
import {Log} from "../services/Log";



@Component({
  selector: 'app-flicking-item',
  template: '<div #item style="position: absolute" ><template #playercontainer></template></div>',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class FlickingItemComponent implements OnDestroy {
    @ViewChild('playercontainer', {read: ViewContainerRef, static: true})
    entry: ViewContainerRef;

    @ViewChild('item', {static: true}) item;

    editMode = false;

    playerService: PlayerBaseService;
    resolver: ComponentFactoryResolver;

    parentPlayer;
    childComponent;

    constructor(protected injector: Injector) {
        this.resolver = injector.get(ComponentFactoryResolver);
        this.playerService = injector.get('playerService');
    }

    @Input()
    set setParentPlayer(parentPlayer) {
        this.parentPlayer = parentPlayer;
    }

    @Input()
    set setEditMode(editMode) {
        this.editMode = editMode;
    }

    @Input()
    set setPage(page) {
        page.$obs = this.createPage(page);
    }

    createPage(page): Observable<any> {
        const player = page.Player[0];
        if (player.$.src != null) {
            const sceneId = player.$.src;
            return (<CachingService>this.playerService.caching).getRecord("scenes", sceneId).pipe(
                switchMap(scene => {
                    const player2 = JSON.parse(JSON.stringify(scene.json.Player));
                    this.childComponent = this.createComponent(SceneComponent, this.editMode, -1);
                    this.childComponent.scaleX = this.parentPlayer.scaleX;
                    this.childComponent.scaleY = this.parentPlayer.scaleY;

                    const layout = player2.Data[0].Layout[0];
                    const actualWidth = Math.floor(Number(layout.$.width) * this.parentPlayer.scaleX);
                    const actualHeight = Math.floor(Number(layout.$.height) * this.parentPlayer.scaleY);
                    const style = this.item.nativeElement.parentElement.style;
                    style.width = actualWidth + 'px';
                    style.height = actualHeight + 'px';
                    this.parentPlayer.updatePanels();

                    (<SceneComponent>this.childComponent).childProviderData = page.childProviderData;

                    return this.childComponent.load(player2);
                }),
                switchMap(child => {

                    return of(child);
                }),
                catchError(err => {
                    Log.debug();
                    return of('a');
                }),
            )
        } else {
            const playerId = player.$.player;
            let pixiClass: any = this.playerService.getComponentClasses(playerId);
            const blockingTime = this.playerService.getComponentBlockingTime(playerId);
            const childComponent = this.createComponent(pixiClass, this.editMode, blockingTime);
            //???childComponent.display(false);
            return childComponent.load(player).pipe(
                switchMap(child => {
                    //???child.display(true);
                    const style = this.item.nativeElement.parentElement.style;
                    style.width = child.actualWidth + 'px';
                    style.height = child.actualHeight + 'px';
                    return of(child);
                }),
                catchError(err => {
                    Log.debug();
                    return of('a');
                }),
            )
        }
    }


    createComponent(cmpClass: any, editMode: boolean, blockingTime): PlayerBase {
        let childComponent: PlayerBase;
        const factory = this.resolver.resolveComponentFactory(cmpClass);
        const componentRef = this.entry.createComponent(factory);
        childComponent = <PlayerBase>componentRef.instance;
        childComponent.hostView = componentRef.hostView;
        childComponent.init(this.parentPlayer, editMode, blockingTime);
        return childComponent;
    }

    ngOnDestroy() {
        if (this.childComponent != null) {
            this.childComponent.destroy();
            this.childComponent = null;
        }
    }
}
